export default function TelegramIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.39327 13.317C10.6183 9.8985 15.4362 7.64479 17.8468 6.55591C24.7296 3.44693 26.1598 2.90687 27.092 2.88884C27.297 2.88511 27.7554 2.94029 28.0524 3.20196C28.3031 3.42291 28.3721 3.72138 28.4051 3.93086C28.4381 4.14035 28.4792 4.61755 28.4465 4.99043C28.0735 9.24638 26.4597 19.5745 25.6386 24.3412C25.2912 26.3582 24.6071 27.0345 23.9448 27.1006C22.5056 27.2445 21.4127 26.0677 20.0187 25.0753C17.8374 23.5225 16.6051 22.5558 14.4877 21.0405C12.0407 19.2894 13.627 18.3269 15.0215 16.7539C15.3865 16.3423 21.7279 10.0783 21.8506 9.51004C21.866 9.43897 21.8802 9.17406 21.7353 9.03418C21.5904 8.89429 21.3765 8.94213 21.2222 8.98017C21.0034 9.0341 17.5187 11.5354 10.7681 16.4841C9.77896 17.2217 8.88305 17.5811 8.08034 17.5623C7.19543 17.5415 5.49319 17.0189 4.22776 16.5722C2.67565 16.0243 1.44207 15.7346 1.54949 14.8041C1.60544 14.3194 2.22003 13.8237 3.39327 13.317Z"
        fill="black"
      />
    </svg>
  );
}
